export { default } from "./SpringScrollbars";



// WEBPACK FOOTER //
// ./src/components/SpringScrollbars/index.js